/* Odette & Opal — recently viewed (localStorage, no app) */
(function () {
  const KEY = 'oo_recently_viewed';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); } catch (e) { /* noop */ }
  }
  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      const current = this.dataset.current;
      const root = this.dataset.root || '/';
      const limit = parseInt(this.dataset.limit || '4', 10);

      let list = read().filter((h) => h && h !== current);
      // record current for next time
      if (current) {
        const updated = [current, ...read().filter((h) => h !== current)];
        write(updated);
      }
      if (!list.length) return;

      const grid = this.querySelector('[data-recent-grid]');
      const wanted = list.slice(0, limit);

      /* The card comes from the theme rather than from here.

         These used to be assembled in this file, which made them the only
         cards on the site with no colour name, no swatches, no wishlist heart
         and no badges: a second, poorer copy of the card that quietly fell
         behind the real one every time the real one changed. Asking Shopify to
         render the card section for each handle means there is one card in the
         theme and this row shows it.

         brand-card is a custom element, so the swatches and size chips wire
         themselves up as soon as the markup lands. */
      Promise.all(
        wanted.map((h) =>
          fetch(`${root}products/${h}?section_id=brand-card-fragment`)
            .then((r) => (r.ok ? r.text() : null))
            .catch(() => null)
        )
      ).then((chunks) => {
        const cards = chunks.filter(Boolean);
        if (!cards.length) return;
        grid.innerHTML = cards
          .map((html) => `<li class="brand-recent__item">${html}</li>`)
          .join('');
        this.hidden = false;
      });
    }
  }

  if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);
})();
